export default __webpack_public_path__ + "static/media/loginImage.f704c879.png";